import moment from 'moment';

export const formatTimeSlot = (time: string) => {
  if (!time || typeof time !== 'string') return;
  const timeValue = time.split('T')[1].split('.')[0];

  return moment(timeValue, ['HH:mm']).format('h:mm A');
};
